import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import CardHeading from "../../UI/Headings/CardHeading";

export function ProviderDetails(props) {
  let { existingIntakePractices, onclick, providerDetails } = props;

  return (
    <DashboardCard2
      Actions={
        <Button2 onPress={onclick} variant="text">
          Edit
        </Button2>
      }
      data-public="true"
      title="Provider Details"
    >
      <div className="row no-gutters mt-4">
        <div className="col-12 col-lg-6">
          <CardHeading className="fs-14 mx-0 mx-md-3" text="Provider Name" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.name}</p>
        </div>

        <div className="col-12 col-lg-6">
          <CardHeading className="fs-14 mx-0 mx-md-3" text="Email Address" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.email}</p>
        </div>
      </div>

      <div className="row no-gutters mt-4">
        <div className="col-12 col-lg-6">
          <CardHeading className="fs-14 mx-0 mx-md-3" text="CP Credentials" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.cp_credentials}</p>
        </div>

        <div className="col-12 col-lg-6">
          <CardHeading className="fs-14 mx-0 mx-md-3" text="NPI Number" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.npi_number}</p>
        </div>
      </div>

      <div className="row no-gutters mt-4">
        <div className="col-12 col-lg-6">
          <CardHeading className="fs-14 mx-0 mx-md-3" text="Mobile" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.mobile}</p>
        </div>
        <div className="col-12 col-lg-6">
          <CardHeading className="fs-14 mx-0 mx-md-3" text="Provider Type" />
          <p className="fs-14 mx-0 mx-md-3 mb-4">{providerDetails.provider_type}</p>
        </div>
      </div>

      {providerDetails.provider_type === "BEHAVIORAL_INTAKE" && (
        <div className="row no-gutters my-4">
          <div className="col-12 col-lg-6">
            <CardHeading className="fs-14 mx-0 mx-md-3" text="Intake Coordinator For Practice(s)" />

            <ul className="fs-14 mx-0 mx-md-3 mb-4">
              {existingIntakePractices &&
                existingIntakePractices.map((intakePractice) => {
                  return (
                    <li key={intakePractice.value || intakePractice.label}>
                      {intakePractice.label}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      )}
    </DashboardCard2>
  );
}
